export const sum = (source, selector) => {
    if (selector) {
        return sum2(source, selector);
    }
    else {
        return sum1(source);
    }
};
const sum1 = (source) => {
    let total = 0;
    for (const value of source) {
        total += value;
    }
    return total;
};
const sum2 = (source, selector) => {
    let total = 0;
    for (const value of source) {
        total += selector(value);
    }
    return total;
};
